import moment from 'moment'
import React from 'react'
import { Col, Row } from 'reactstrap'
import { numberWithCommas } from '../../utils/customFunction'
import { IoAddCircle } from 'react-icons/io5'
import { AiFillMinusCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import CardColComponent from '../genericCardComponent/CardColComponent'

function MarketPortfolioTable(
    {
        data,
        itemsToShow = "",
        getImageSrc = "",
        setModalFlag = "",
        setSelectedItem = "",
        setUnitsLimit = "",
    }:
        {
            data?: any
            itemsToShow?: any
            getImageSrc?: any
            setModalFlag?: any
            setSelectedItem?: any
            setUnitsLimit?: any
        }
) {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);

    return (
        <div className="table-responsive">
            <table
                className="table mt-0">
                <tbody>
                    {data?.map((item, index) => {

                        const avgUnitCost = Number(item?.average_cost_per_unit || 0)?.toFixed(2)
                        const totalCost = Number(item?.total_amount || 0)?.toFixed(2)

                        return (
                            <tr key={index}>
                                <td
                                    style={{
                                        width: "120px",
                                        maxWidth: "180px"
                                    }}
                                    className='border-y'>
                                    <div
                                        style={{ lineHeight: "normal" }}
                                        className='d-flex align-items-center w-75'>
                                        <img
                                            className='mr-2'
                                            src={getImageSrc(item?.symbol)}
                                            width={50}
                                            height={50}
                                            style={{
                                                objectFit: "contain",
                                                objectPosition: "center"
                                            }}
                                        />
                                        <div style={{ width: "inherit" }} className='d-flex flex-column'>
                                            <small style={{ opacity: "0.4" }}>Security</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                data-toggle="tooltip" data-placement="top" title={item?.security_type}
                                                className='mb-0 text-primary table_heading_large text-truncate'>
                                                {item?.security_type}
                                            </p>
                                            <small
                                                data-toggle="tooltip" data-placement="top" title={item?.name}
                                                className='text-info small_heading text-truncate'>
                                                {item?.name}
                                            </small>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    style={{
                                        minWidth: "200px"
                                    }}
                                    className='border-y'>
                                    <Row
                                        style={{
                                            rowGap: "12px"
                                        }}
                                    >
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex flex-column justify-content-center align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Next Coupon</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                {item?.next_coupon_date ?
                                                    moment(item?.next_coupon_date)?.format("DD-MMM-YYYY") : "N/A"
                                                }
                                            </p>
                                        </Col>
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex flex-column justify-content-center align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Days to Coupon</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                {item?.coupon_days || 0}
                                            </p>
                                        </Col>
                                    </Row>
                                </td>
                                <td className='border-y'>
                                    <Row style={{ rowGap: "12px" }}>
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex flex-column justify-content-center align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Units</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                {numberWithCommas(parseFloat(item?.units || 0)?.toFixed(4))}
                                            </p>
                                        </Col>
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex flex-column justify-content-center align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Avg Unit Cost</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                <small className='xSmall'>Rs.</small>
                                                {numberWithCommas(avgUnitCost?.toString()?.includes(".") ?
                                                    avgUnitCost?.toString()?.split(".")[0] :
                                                    avgUnitCost || 0)
                                                }
                                                <small className='xSmall'>
                                                    .{avgUnitCost?.toString()?.includes(".") ?
                                                        avgUnitCost?.toString()?.split(".")[1] :
                                                        "00"
                                                    }
                                                </small>
                                            </p>
                                        </Col>
                                    </Row>
                                </td>
                                <td className='border-y'>
                                    <Row style={{ rowGap: "12px" }}>
                                        <Col
                                            xl={12}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex justify-content-center flex-column align-items-center'>
                                            <small className='text-center d-flex align-items-center' style={{ opacity: "0.4" }}>
                                                Total Cost
                                            </small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                <small className='xSmall'>Rs.</small>
                                                {numberWithCommas(totalCost?.toString()?.includes(".") ?
                                                    totalCost?.toString()?.split(".")[0] :
                                                    totalCost || 0)
                                                }
                                                <small className='xSmall'>
                                                    .{totalCost?.toString()?.includes(".") ?
                                                        totalCost?.toString()?.split(".")[1] :
                                                        "00"
                                                    }
                                                </small>
                                            </p>
                                        </Col>
                                    </Row>
                                </td>

                                <td className='border-y'>
                                    <Row style={{ rowGap: "12px" }}>
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex justify-content-center flex-column align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Unrealized Gain/Loss</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                {/* <small className='xSmall'>Rs.</small> */}
                                                {numberWithCommas(item?.unrealized_gain_loss?.toString()?.includes(".") ?
                                                    item?.unrealized_gain_loss?.toString()?.split(".")[0] :
                                                    item?.unrealized_gain_loss || 0)
                                                }
                                                <small className='xSmall'>
                                                    .{item?.unrealized_gain_loss?.toString()?.includes(".") ?
                                                        item?.unrealized_gain_loss?.toString()?.split(".")[1] :
                                                        "00"
                                                    } Units
                                                </small>
                                            </p>
                                        </Col>
                                        {/* <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex justify-content-center flex-column align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Gain/Loss Amount</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary table_heading_large w-100 text-center'>
                                                <small className='xSmall'>Rs.</small>
                                                {numberWithCommas(item?.gain_loss_amount?.toString()?.includes(".") ?
                                                    item?.gain_loss_amount?.toString()?.split(".")[0] :
                                                    item?.gain_loss_amount || 0)
                                                }
                                                <small className='xSmall'>
                                                    .{item?.gain_loss_amount?.toString()?.includes(".") ?
                                                        item?.gain_loss_amount?.toString()?.split(".")[1] :
                                                        "00"
                                                    }
                                                </small>
                                            </p>
                                        </Col> */}
                                    </Row>
                                </td>

                                <td className='border-y'>
                                    <Row style={{ rowGap: "12px" }}>
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex justify-content-center flex-column align-items-center'>
                                            <small className='text-center' style={{ opacity: "0.4" }}>Unredeemed Amount</small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary w-100 text-center table_heading_large'>
                                                {numberWithCommas(item?.unredeem_value || 0)}
                                            </p>
                                        </Col>
                                        <Col
                                            xl={6}
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            style={{ lineHeight: "normal" }}
                                            className='d-flex justify-content-center flex-column align-items-center'>
                                            <small
                                                className='text-center'
                                                style={{ opacity: "0.4" }}
                                            >
                                                Remaining Days
                                            </small>
                                            <p
                                                style={{ fontWeight: 600 }}
                                                className='mb-0 text-primary w-100 text-center table_heading_large'>
                                                {numberWithCommas(moment(item?.maturity_date).diff(moment(), 'days') || 0)}
                                            </p>
                                        </Col>
                                    </Row>
                                </td>
                                <td className='border-y'>
                                    <div
                                        style={{ lineHeight: "normal" }}
                                        className='d-flex mt-1 flex-column align-items-center'>
                                        <small
                                            style={{ opacity: "0.4" }}
                                            className='mb-1'
                                        >
                                            Action
                                        </small>
                                        <div
                                            style={{ width: "-webkit-fill-available" }}
                                            className='d-flex justify-content-center align-items-center'>
                                            <div className='d-flex flex-column mr-0'>
                                                <div
                                                    style={{
                                                        maxWidth: "90px",
                                                        border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                        borderRadius: "18px"
                                                    }}
                                                    className='position-relative mb-1 pl-4'
                                                >
                                                    Maturity
                                                    <IoAddCircle
                                                        onClick={() => {
                                                            setModalFlag("Maturity")
                                                            setSelectedItem(item)
                                                            setUnitsLimit(item?.units)
                                                        }}
                                                        className='text-info'
                                                        style={{
                                                            position: "absolute",
                                                            left: "-9px",
                                                            top: "-4px",
                                                            width: "30px",
                                                            height: "30px",
                                                            cursor: "pointer"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "90px",
                                                        border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                        borderRadius: "18px"
                                                    }}
                                                    className='position-relative mb-1 pl-4'
                                                >
                                                    Sell
                                                    <AiFillMinusCircle
                                                        onClick={() => {
                                                            setModalFlag("Sell")
                                                            setSelectedItem(item)
                                                            setUnitsLimit(item?.units)
                                                        }}
                                                        className='text-primary'
                                                        style={{
                                                            position: "absolute",
                                                            left: "-9px",
                                                            top: "-4px",
                                                            width: "30px",
                                                            height: "30px",
                                                            cursor: "pointer"
                                                        }}
                                                    />
                                                </div>
                                                <div
                                                    style={{
                                                        maxWidth: "90px",
                                                        border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                        borderRadius: "18px"
                                                    }}
                                                    className='position-relative pl-4'
                                                >
                                                    Coupon
                                                    <IoAddCircle
                                                        onClick={() => {
                                                            setModalFlag("Coupon")
                                                            setSelectedItem(item)
                                                            setUnitsLimit(item?.units)
                                                        }}
                                                        className='text-info'
                                                        style={{
                                                            position: "absolute",
                                                            left: "-9px",
                                                            top: "-4px",
                                                            width: "30px",
                                                            height: "30px",
                                                            cursor: "pointer"
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default MarketPortfolioTable